
export default function IntroSection() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="bg-[#E8E1DC] p-8 md:p-12 rounded-2xl">
          <h2 className="text-2xl md:text-3xl font-bold text-[#5C1A24] mb-6" style={{ fontFamily: '"Playfair Display", serif' }}>
            Excelência em cada detalhe
          </h2>
          <div className="text-lg text-[#3F3F3F] leading-relaxed space-y-4">
            <p>
              Na P&P Engenharia e Arquitetura, cada serviço é pensado para entregar resultado, segurança e sofisticação.
            </p>
            <p>
              Oferecemos soluções integradas que unem design autoral, rigor técnico e gestão precisa — do primeiro traço à entrega final.
            </p>
            <p className="font-medium text-[#5C1A24]">
              Aqui, o luxo não está apenas no visual, mas na tranquilidade de saber que tudo foi feito do jeito certo.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
